import { AfterLoad, Column, Entity, JoinColumn, JoinTable, ManyToOne, OneToMany } from 'typeorm';
import { OrderedModel } from '@nsk-app/models/orderedModel';
import { ContactInformation } from '@nsk-app/models/contactInformation';
import { Hospital } from '@nsk-app/models/hospital';
import { Phase } from '@nsk-app/models/phase';

@Entity('topics', {
  orderBy: {
    order: 'ASC'
  }
})
export class Topic extends OrderedModel {

  @Column()
  name: string;

  @Column()
  hospital_site_id: number;

  @Column()
  contact_id: number;

  @ManyToOne(type => ContactInformation, {eager: true})
  contact: ContactInformation;

  @ManyToOne(type => Hospital, hospital => hospital.topics, {lazy: true})
  @JoinColumn({name: 'hospital_site_id'})
  hospital: Promise<Hospital>;

  @OneToMany(type => Phase, phase => phase.topic, {eager: true})
  phases?: Phase[];

  @AfterLoad()
  sortAttributes() {
    if (this?.phases?.length) {
      this.phases.sort((a, b) => (a.order < b.order ? -1 : a.order === b.order ? 0 : 1));
    }
  }

}
